import { mapActions, mapGetters } from "vuex";

export const vesselMixin = {

    data() {
        return {
            vesselId: this.$route.params.id
        }
    }

}
